module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Acknowledgements"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('b', [_vm._v("Acknowledgements")])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" would like to thank all those people who have inspired me to undertake this work, and also those who provided me with the encouragement and support to be able to complete it.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I would like to thank Pavel Simak for his excellent cover art ‘Eagles in the Dust – The Fall of Valens’. I would also like to thank John Hills for supplying the map and diagrams plus his thoughtful comments.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I would like to thank Michael King Macdona for helping me with translations where needed, for his knowledge of the Battle of Adrianople, and for the many interesting conversations we have had in connection with the Late Roman Empire. I would also like to thank Francis Hagan for similar reasons and for the insights he has provided.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Further mention must be made to Chris Richards and David Mather for their comments and suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("I would like to thank all those historians, academics and researchers whose invaluable work I have been able to consult during my own research for this book. And I would like to thank Ammianus Marcellinus for providing me with many hours of entertaining reading.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Due to the amount of material that is available concerning the Late Roman Empire, its army and its enemies, it would be difficult to give acknowledgment to all those whose works I have consulted and so I apologize to those who I have not done so.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Finally I would like to thank Ann for putting up with piles of books and papers lying around the house and for supplying me with endless cups of tea and other beverages upon demand!")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('i', [_vm._v("To all those I have loved and lost")])])])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59713784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Acknowledgements.vue
// module id = 69
// module chunks = 0